export const INFO = {
  updateDate: '2025年12月30日',
  effectiveDate: '2024年1月1日',
  version: 'v0.2.2',
  contact: {
    email: 'support@furiflow.com',
    website: 'https://furiflow.com',
    address: '请通过邮箱联系获取详细地址',
  },
};
